import { AnyAction, Reducer } from "redux";

interface ScrollState {
  isScrolled: boolean;
}

const initialState: ScrollState = {
  isScrolled: false,
};

const scrollReducer: Reducer<ScrollState, AnyAction> = (state = initialState, action) => {
  switch (action.type) {
    case "SCROLL":
      return {
        ...state,
        isScrolled: action.payload,
      };
    default:
      return state;
  }
};

export default scrollReducer;
